var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bd-table-list',{ref:"bons_de_commande_resource",attrs:{"breadcrumb":_vm.breadcrumb,"title":"Bons de commande","subtitle":"Recherche de bons de commande","autocomplete_idHistory":"account-statements","bdTable":"bon_de_commande","actions":_vm.actions,"fields":_vm.fields,"Api":_vm.Api,"directLoad":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }